import React from 'react';

import { useAppDispatch, useAppSelector } from '~redux/hooks';
import combinedActions from '~redux/combinedActions';

import TabSelector from '~components/atoms/TabSelector';
import TabDisplay from '~components/atoms/TabDisplay';

import APIKeySettings from './APIKeySettings';

import { SettingsTabDisplayMap, SettingTabsEnum } from '~utils/enums';

import * as Styles from './_settings.module.scss';
import SilverAPIKeySettings from './SilverAPIKeySettings';

const Settings = () => {
    const dispatch = useAppDispatch();

    const selectedTab = useAppSelector(state => state.setting.selectedTab);

    const setSelectedTab = (tab: SettingTabsEnum) => {
        dispatch(combinedActions.settingSetGlobalSettingsIsEditing(false));
        dispatch(combinedActions.settingsSetSelectedTab(tab));
    };

    const tabValues = [
        // hide tabs
        // {
        //     label: SettingTabsEnum[SettingTabsEnum.Global],
        //     value: SettingTabsEnum.Global,
        // },
        {
            label: SettingsTabDisplayMap[SettingTabsEnum.APIKey],
            value: SettingTabsEnum.APIKey,
        },
        {
            label: SettingsTabDisplayMap[SettingTabsEnum.SilverAPIKey],
            value: SettingTabsEnum.SilverAPIKey,
        },
    ];

    const tabs = [
        // hide tabs
        // {
        //     name: SettingTabsEnum[SettingTabsEnum.Global],
        //     element: <GlobalSettings />,
        // },
        {
            name: SettingsTabDisplayMap[SettingTabsEnum.APIKey],
            element: <APIKeySettings />,
        },
        {
            name: SettingsTabDisplayMap[SettingTabsEnum.SilverAPIKey],
            element: <SilverAPIKeySettings />,
        },
    ];

    return (
        <TabSelector
            tabs={tabValues}
            selectedTab={selectedTab}
            setSelectedTab={setSelectedTab}
        >
            <TabDisplay
                tabs={tabs}
                currentTab={SettingsTabDisplayMap[selectedTab]}
                containerStyle={Styles['tab-display']}
            />
        </TabSelector>
    );
};

export default Settings;
